import AuthProvider from "./AuthProvider";
import DataProvider from "./DataProvider";
import { SnackbarProvider } from "notistack";
import ReservedFormProvider from "./ReservedFormProvider";
import { LogoutModalProvider } from "./LogoutModalProvider";
import React from "react";
import { SyncProvider } from 'store/SyncContext';
import { NetworkStatusProvider } from "hooks/useNetworkStatus";

const Providers = ({ children }) => {
	return (
		<NetworkStatusProvider>
		<SyncProvider>
			<AuthProvider>
				<DataProvider>
					<LogoutModalProvider>
						<ReservedFormProvider>
							<SnackbarProvider
								preventDuplicate
								anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
								autoHideDuration={3000}
								classes={{ containerRoot: "snackbarContainer" }}
								maxSnack={3}>
								{children}
							</SnackbarProvider>
						</ReservedFormProvider>
					</LogoutModalProvider>
				</DataProvider>
			</AuthProvider>
		</SyncProvider>
		</NetworkStatusProvider>
	);
};
export default Providers;
